import { useState } from "react";
import { AuthPageLayout } from "./auth-page-layout";
import { GoogleSignInButton } from "./google-sign-in-button";
import { OAuthDivider } from "./oauth-divider";
import {
  Button,
  FormError,
  FormField,
  PasswordInput,
  TextInput,
} from "@/components/ui";

export function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setIsSubmitting(true);
    console.log("[workshop] Login submitted:", { email, password });

    // Simulate async delay then reset
    setTimeout(() => {
      setIsSubmitting(false);
    }, 1500);
  }

  return (
    <AuthPageLayout>
      <div className="flex flex-col gap-6">
        <h2
          className="text-2xl font-semibold text-primary"
          data-testid="login-heading"
        >
          Sign in to your account
        </h2>

        <FormError
          message={error}
          className="mt-0"
          data-testid="login-error"
        />

        <GoogleSignInButton
          label="Sign in with Google"
          data-testid="login-google-button"
        />

        <OAuthDivider />

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-5"
          data-testid="login-form"
        >
          <FormField label="Email address" htmlFor="email">
            <TextInput
              id="email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="h-12 rounded-xl text-sm px-4"
              data-testid="login-email"
            />
          </FormField>

          <FormField label="Password" htmlFor="password">
            <PasswordInput
              id="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="h-12 rounded-xl text-sm"
              data-testid="login-password"
            />
          </FormField>

          <Button
            type="submit"
            variant="secondary"
            size="lg"
            disabled={isSubmitting}
            className="w-full !bg-glass-fill liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
            data-testid="login-submit"
          >
            {isSubmitting ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        {/* Bottom links */}
        <div className="flex flex-col items-center gap-2">
          <p className="text-canvas-lg text-secondary">
            Don&apos;t have an account?{" "}
            <button
              type="button"
              onClick={() => console.log("[workshop] Navigate to register")}
              className="font-semibold text-accent hover:underline"
              data-testid="register-link"
            >
              Sign up here
            </button>
          </p>
          <p className="text-canvas-lg text-secondary">
            Trouble signing in?{" "}
            <button
              type="button"
              onClick={() => console.log("[workshop] Navigate to forgot-password")}
              className="font-semibold text-accent hover:underline"
              data-testid="forgot-password-link"
            >
              Reset password
            </button>
          </p>
        </div>
      </div>
    </AuthPageLayout>
  );
}
